export function countdown(callback: Function, numberOfSeconds: number) {
  callback(numberOfSeconds);
  
  const interval = setInterval(() => {
    if (numberOfSeconds > 0) {
      numberOfSeconds--;
      callback(numberOfSeconds);
    } else {
      clearInterval(interval);
    }
  }, 1000);

  return () => clearInterval(interval);
}